import { Box, Stack, Alert, Skeleton } from "@mui/material";
import DatasetResult from "catalog/components/DatasetResult";
import useCatalogSearch, { PAGE_SIZE } from "catalog/hooks/useCatalogSearch";
import EmptyState from "~/components/EmptyState";
import LimitedPagination from "~/components/LimitedPagination";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { TableEntity } from "~/types/interfaces/catalogResponse";

const Datasets = () => {
  useDocumentTitle("Tables");
  // Note: App header is managed by DataBrowser parent component
  const { data, error, isLoading } = useCatalogSearch<TableEntity>("table");
  const datasets = data?.hits?.hits.filter(({ _source }) => _source.entityType === "table") ?? [];
  const total = data?.hits?.total?.value ?? 0;

  if (error) {
    return (
      <Box sx={{ px: 4, py: 2, minHeight: "100%" }}>
        <Alert severity="error" variant="outlined" data-testid="tables-list-error">
          An error occurred fetching search results.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ px: 4, py: 1, minHeight: "100%" }}>
      <Stack flex={1} data-testid={datasets.length > 0 ? "tables-list" : undefined}>
        {datasets.map(({ _source: dataset, highlight }) => (
          <DatasetResult
            key={dataset.id}
            entity={dataset}
            highlight={highlight}
            source="tables_list"
          />
        ))}
        {!datasets.length &&
          isLoading &&
          Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height={120} variant="rounded" sx={{ my: 2 }} />
          ))}
        {datasets.length === 0 && !isLoading && (
          <Box data-testid="tables-list-empty">
            <EmptyState />
          </Box>
        )}
      </Stack>
      <LimitedPagination
        total={total}
        defaultPageSize={PAGE_SIZE}
        analyticsPrefix="catalog_search"
      />
    </Box>
  );
};

export default Datasets;
